<template>
  <div class="airwallex_box">
    <h2>DropIn integration</h2>
    <p id="loading">Loading...</p>
    <p id="error"
       style="display: none" />
    <div id="dropIn"
         :style="{ display: 'block' }" />
  </div>
</template>
      
      <script>
// STEP #1: Import airwallex-payment-elements package
import { getSessionStorage, setSessionStorage } from '@/utils/stage'
const data1 = {
  payment_intent_id: 'int_hkdmtt6wvgzeezeap59',
  client_secret:
    'eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3MjQ4Mjc4NjcsImV4cCI6MTcyNDgzMTQ2NywidHlwZSI6ImNsaWVudC1zZWNyZXQiLCJwYWRjIjoiSEsiLCJhY2NvdW50X2lkIjoiNWJhNGY2NTQtNWQzZS00MDI1LThmZDEtODJiODI2YzUzMmE4IiwiaW50ZW50X2lkIjoiaW50X2hrZG10dDZ3dmd6ZWV6ZWFwNTkiLCJjdXN0b21lcl9pZCI6ImN1c19oa2RteGdqajVnejA2bXQzZGZyIiwiYnVzaW5lc3NfbmFtZSI6ImRlbW8rZmFudGFuZ0BhaXJ3YWxsZXguY29tIn0.qKVw87TM6QSA-XEJAvjXRw04JK7jxL34HGhYCXXhuio',
  out_trade_no: '20240828145106000001928567002907',
}
setSessionStorage('airwallexData', JSON.stringify(data1))
import { createElement, loadAirwallex } from 'airwallex-payment-elements'
const airwallexData = JSON.parse(getSessionStorage('airwallexData'))
console.log('airwallexData', airwallexData)
const intent_id = airwallexData ? airwallexData.payment_intent_id : ''
const client_secret = airwallexData ? airwallexData.client_secret : ''
// const intent_id =
//   'eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3MjQ3NTI3NzksImV4cCI6MTcyNDc1NjM3OSwidHlwZSI6ImNsaWVudC1zZWNyZXQiLCJwYWRjIjoiSEsiLCJhY2NvdW50X2lkIjoiNWJhNGY2NTQtNWQzZS00MDI1LThmZDEtODJiODI2YzUzMmE4IiwiaW50ZW50X2lkIjoiaW50X2hrZG03NmNmdGd6ZGdoa3pwNGEiLCJjdXN0b21lcl9pZCI6ImN1c19oa2RteGdqajVnejA2bXQzZGZyIiwiYnVzaW5lc3NfbmFtZSI6ImRlbW8rZmFudGFuZ0BhaXJ3YWxsZXguY29tIn0.uqYdbqyGTU4tPQ_Ylo4YfWaq7dc-tGP63fxaio8jr3E'
// const client_secret = 'int_hkdm76cftgzdghkzp4a'
const currency = 'JPY'

const init = () => {
  loadAirwallex({
    env: 'demo',
    origin: window.location.origin,
  }).then(() => {
    const element = createElement('dropIn', {
      intent_id,
      client_secret,
      currency,
      methods: ['card', 'konbini', 'payeasy'],
    })
    element.mount('dropIn')
  })
}

const onReady = (event) => {
  document.getElementById('loading').style.display = 'none'
  document.getElementById('dropIn').style.display = 'block'
  console.log(`Element is mounted: ${JSON.stringify(event.detail)}`)
}

const onSuccess = (event) => {
  //   window.alert(`Confirm success with ${JSON.stringify(event.detail)}`)
  console.log(event.detail)
}

const onError = (event) => {
  const { error } = event.detail
  document.getElementById('error').style.display = 'block' // Example: show error block
  document.getElementById('error').innerHTML = error.message // Example: set error message
  console.error('There was an error', error)
}

export default {
  name: 'DropIn',
  mounted() {
    init()
    const domElement = document.getElementById('dropIn')
    domElement.addEventListener('onReady', onReady)
    domElement.addEventListener('onSuccess', onSuccess)
    domElement.addEventListener('onError', onError)
  },
  beforeDestroy() {
    const domElement = document.getElementById('dropIn')
    // Be sure to clean up event listeners when component unmounts
    if (domElement) {
      domElement.removeEventListener('onReady', onReady)
      domElement.removeEventListener('onSuccess', onSuccess)
      domElement.removeEventListener('onError', onError)
    }
  },
}
</script>
      
      <style>
/* Custom styling for the element */
.airwallex_box {
  width: 700px;
  background: rgb(255, 255, 255);
  border-radius: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  box-sizing: border-box;
}
#dropIn {
  width: 540px;
  margin: 48px auto;
}
</style>